import "./activity-stepper.less"
import templateUrl from "./activity-stepper-template.html"

export const ActivityStepperComponent = {
    bindings: {
        activities: "<"
    },
    templateUrl,
    controllerAs: "vm",
    controller: function ApexActivityStepperController() {
        'ngInject'
        const vm = this;
        vm.selected = isSelected;
        vm.toggleListItems = toggleListItems;
        vm.init = init

        function init() {

        }

        const selected = 0;

        function isSelected(idx) {
            return selected === idx;
        }

        function toggleListItems(index) {

            vm.activities[index].expanded = !vm.activities[index].expanded;

            for (let i = 0; i < vm.activities.length; i++) {

                if (vm.activities[i].expanded === true && i !== index) {
                    vm.activities[i].expanded = false;
                }
            }
        }
    }
}
